<script>

import CampaignSummary from "@/components/campaignWidgets/campaignSummary";
import StatCard from "@/components/statCard";
import axios from "axios";
import CampaignPerformance from "@/components/campaignWidgets/campaignPerformance";
import CampaignEngagementTimeline from "@/components/campaignWidgets/campaignEngagementTimeline";
import CampaignSocialNetworkBreakdown from "@/components/campaignWidgets/campaignSocialNetworkBreakdown";
import CampaignRoadmap from "@/components/campaignWidgets/campaignRoadmap";
import CampaignTopCities from "@/components/campaignWidgets/campaignTopCities";
import CampaignPostsByStatus from "@/components/campaignWidgets/campaignPostsByStatus";

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  components: {
    CampaignPostsByStatus,
    CampaignTopCities,
    CampaignRoadmap,
    CampaignSocialNetworkBreakdown,
    CampaignEngagementTimeline,
    CampaignPerformance,
    StatCard,
    CampaignSummary,
  },
  data() {
    return {
      campaignOverview: null,
    };
  },
  computed: {
    userType () {
      return this.$store.getters['user/userType'];
    },
    statData() {
      const campaignAgreements = this.campaignOverview.campaign_agreements ?? []
      const agreementStatuses = campaignAgreements.reduce((result, item) => {
        if (!result.hasOwnProperty(item.status)) {
          result[item.status] = 0
        }
        result[item.status] ++;

        return result;
      }, {})

      const offers = agreementStatuses.offer ?? 0;
      const inNegotiation = (agreementStatuses.pending ?? 0) + (agreementStatuses.interested ?? 0);
      const canceledAndRemoved = (agreementStatuses.canceled ?? 0) + (agreementStatuses.aborted ?? 0)
      const signed = agreementStatuses.signed ?? 0;

      return [
        {
          icon: "fas fa-paper-plane",
          title: "Offers",
          value: offers.toString()
        },
        {
          icon: "fas fa-user-clock",
          title: "In negotiation",
          value: inNegotiation.toString()
        },
        {
          icon: "fas fa-ban",
          title: "Canceled & Removed",
          value: canceledAndRemoved.toString()
        },
        {
          icon: "fas fa-handshake",
          title: "Signed",
          value: signed.toString()
        },
      ]
    }
  },
  async beforeMount() {
    // TODO: load before
    this.$store.commit('loader/START_LOADING', null, { root: true });
    try{
      const response = await axios.get(`/${this.userType}/campaign/${this.campaign._id}/overview`)
      this.campaignOverview = response.data
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.$store.commit('loader/END_LOADING', null, { root: true });
    }
  }
};
</script>

<template>
  <div v-if="campaignOverview">

<!--    <div class="row">-->
<!--      <div class="col-lg-12">-->
<!--        <campaign-header :campaign="campaign"></campaign-header>-->
<!--      </div>-->
<!--    </div>-->

    <div class="row">
      <div class="col-12 col-lg-4 d-flex">
        <campaign-summary class="card" :campaignOverview="campaignOverview"/>
      </div>

      <div class="col-12 col-lg-8">
        <div class="flex">
          <div class="row ">
            <div class="col-xl-6 d-flex">
              <div class="row">
                <div v-for="stat of statData" :key="stat.icon" class="col-md-6 d-flex">
                  <StatCard :icon="stat.icon" :title="stat.title" :value="stat.value"/>
                </div>
              </div>
            </div>

            <div class="col-xl-6 d-flex">
              <campaign-posts-by-status :campaignOverview="campaignOverview"></campaign-posts-by-status>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-xl-8 d-flex">
        <campaign-performance :campaignOverview="campaignOverview"></campaign-performance>
      </div>
      <div class="col-xl-4">
        <campaign-engagement-timeline :campaignOverview="campaignOverview"></campaign-engagement-timeline>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-4 d-flex">
        <campaign-social-network-breakdown :campaignOverview="campaignOverview"></campaign-social-network-breakdown>
      </div>
      <!-- end col -->
      <div class="col-xl-4 d-flex">
        <campaign-roadmap :campaignOverview="campaignOverview"></campaign-roadmap>
      </div>
      <!-- end col -->
      <div class="col-xl-4 d-flex">
        <campaign-top-cities :campaignOverview="campaignOverview"></campaign-top-cities>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

  </div>
</template>
